import React from 'react'
import classes from './NotificationItem.module.sass'

import { useNotificationItem } from './hooks/useNotificationItem'
import { NotificationTypes } from '../../../../types/enums'
import { NotificationInterface } from '../../../../types/interfaces'
import { useSelector } from 'react-redux'
import { selectDarkTheme } from '../../../../../store/slices/settingsSlice'

type Props = {
  el: NotificationInterface
}

export const NotificationItem = ({ el }: Props) => {
  const { removeNotificationAction, notificationWidth, exit } =
    useNotificationItem(el)
    const darkTheme = useSelector(selectDarkTheme)

  return (
    <div
      className={exit ? classes.CardContainerExit : classes.CardContainer}
      onClick={removeNotificationAction}
    >
      <div className={darkTheme ? classes.ContainerDark : classes.Container}>
        <div className={classes.Message}>{el.text}</div>
        <div
          className={
            el.type === NotificationTypes.ERROR
              ? classes.StatusBar
              : classes.StatusBarPositive
          }
          style={{ width: notificationWidth - 10 }}
        />
        <div className={classes.ClickToHide}>Кликните, чтобы скрыть</div>
      </div>
    </div>
  )
}
